import { Prop, Vue, Watch } from 'vue-property-decorator';

import Component from 'vue-class-component';
import type { ElForm } from 'element-ui/types/form';
import style from './style.vue';
import selectGoods from '@/views/components/selectGoods';
import imgPreview from '@/views/components/imgPreview';
import { noop } from '@/util';
import IPSDialog from '@/views/components/picker/dialog';
import DialogFactory from '@/views/components/picker/dialogFactory';
import { defaultImg } from '@/views/components/newDisplayConfig/shop';
import { IPSService } from '@/services/ipsServices';

/**
 *
 * TEST20190606,TEST20190929,TEST20190929,SALLY002,TEST20190228,1417118,TEST20181227,
 */
@Component({
  components: {},
  mixins: [style],
})
export default class GoodsGroup extends Vue {
  @Watch('selectGoodsList', { immediate: true })
  onSelectChange(n, o) {
    if (n && n.length) {
      this.emitMessage();
    }
  }

  @Prop({ default: '' })
    productCodes: string;

  @Prop({ default: false })
    disabled: boolean;

  max = 150;

  empCode = '';

  @Prop()
    siteId: number; // 网点ID，isCloudMall=1时必填

  @Prop()
    isCloudMall: number; // 0镜像店模式、1云商城模式，云商城模式必填

  public selectGoodsList: GoodsInfo[] = [];
  public selectType = 1;
  public displayValue = 0;

  openSelectGoodsDialog() {
    selectGoods
      .open({
        showBD: false,
        max: this.max - this.selectGoodsList.length,
        empCode: this.empCode,
        siteId: this.siteId,
        isCloudMall: this.isCloudMall,
      })
      .then((res) => {
        this.selectType = res.type;
        // 选中后是merge操作
        res.list.map((i) => {
          if (this.selectGoodsList.every(v => i.productCode !== v.productCode)) {
            this.selectGoodsList.push(i);
          }
        });
        this.emitMessage();
      }, noop);
  }

  mounted() {
    if (this.productCodes && this.productCodes.length > 0) {
      const postParams = {
        siteId: this.siteId,
        isCloudMall: this.isCloudMall,
      };
      postParams[`productCode${this.productCodes.includes(',') ? 's' : ''}`] = this.productCodes;
      (this.selectType === 1 ? IPSService.adminComBatchFindProducts({ postParams }) : IPSService.adminComBatchFindBDProducts({ postParams: { bdCodes: this.productCodes } })).then((res) => {
        let list = [];
        const notFoundCodes = (res.notFoundCodes || '').split(',');
        // 排序 ==>因为是记录顺序的，所以需排序
        this.productCodes.split(',').forEach((key) => {
          list.push(
            res.list.find((v: any) => {
              return v.productCode === key;
            }),
          );
        });
        list = list.filter(v => !!v);

        this.selectGoodsList = list.map((i: any) => {
          i.productImage = i.productImage || i.productImages[0];
          return i;
        }) as GoodsInfo[];
      });
    }

    // this.displayValue = this.display;
  }

  /**
   *  emit  Value
   *
   * 1：选中的商品，2：选中  是否  当前店铺商品无库存则不显示 3 ：选中的是版单号还是货号，
   */
  emitMessage() {
    this.$emit('change', this.selectGoodsList, this.selectType);
  }

  onDeleteGoods(event: Event, index) {
    event.stopPropagation();
    this.selectGoodsList = this.selectGoodsList.filter((v, i) => i !== index);
    this.$emit('change', this.selectGoodsList);
  }

  onImgPreview(img) {
    imgPreview.open({ img }).then(noop, noop);
  }

  render(h) {
    return (
      <div class="goods-group">
        <p class="top">
          {!this.disabled && (
            <div>
              <el-button type="primary" onClick={this.openSelectGoodsDialog} disabled={this.selectGoodsList.length >= this.max}>
                添加商品
              </el-button>
              <span class={['reset', !this.selectGoodsList.length && 'reset-disabled']} onClick={this.reset}>
                重置
              </span>
            </div>
          )}

          {/* <div class="right-wrapper"> */}
          {/*  <el-checkbox */}
          {/*    v-model={this.displayValue} */}
          {/*    true-label={1} */}
          {/*    false-label={0} */}
          {/*    onChange={this.emitMessage.bind(this)}> */}
          {/*    当前店铺商品无库存则不显示 */}
          {/*  </el-checkbox> */}
          {/* </div> */}
        </p>

        <div class="list-wrapper">
          {this.selectGoodsList.length ? (
            <draggable disabled={this.disabled} class="draggableWrapper" v-model={this.selectGoodsList} options={{ animation: 500 }}>
              {this.selectGoodsList.map((i, index) => {
                return (
                  <div class="goods-item" key={i.id} value-key={i.id}>
                    <img src={i.productImage || defaultImg} alt="" class="img" onClick={() => this.onImgPreview(i.productImage)} />
                    {!this.disabled && (
                      <p class="delete" onClick={event => this.onDeleteGoods(event, index)}>
                        删除
                      </p>
                    )}
                  </div>
                );
              })}
            </draggable>
          ) : (
            ''
          )}
          <p class="tip">
            <i class="redText">*&nbsp;</i>最多可添加150个商品，拖动可排序
          </p>
        </div>
      </div>
    );
  }

  reset() {
    this.$confirm('是否重置已选商品?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((res) => {
      if (res == 'confirm') {
        this.selectGoodsList = [];
        this.$emit('change', this.selectGoodsList);
        this.$message.success('重置成功');
      }
    });
  }
}

@DialogFactory
@Component({
  components: { GoodsGroup },
  mixins: [style],
})
export class goodsGroupDialog extends IPSDialog {
  width = '600px';
  title = '追加商品组';
  confirmloading = false;
  productCodes = '';
  display = 1;

  form = {
    productCodes: this.productCodes,
  };

  $refs: {
    form: ElForm;
  };

  siteId = 0; // 网点ID，isCloudMall=1时必填

  isCloudMall; // 0镜像店模式、1云商城模式，云商城模式必填

  onListChange(list, display) {
    this.form.productCodes = list.map(i => i.productCode).join(',');
    this.display = display;
  }

  getResults(): {} {
    return {
      list: this.form.productCodes,
      display: this.display,
    };
  }

  renderContent(h): any {
    return (
      <div class="goodsGroupDialog">
        <el-form props={{ model: this.form }} ref="form" label-width="120px" label-position="left">
          <el-form-item label="商品组" rules={{ required: true, message: '商品组不能为空', trigger: 'blur' }} prop="productCodes">
            {<GoodsGroup onChange={this.onListChange.bind(this)} productCodes={this.form.productCodes || this.productCodes} display={this.display} siteId={this.siteId} isCloudMall={this.isCloudMall} />}
          </el-form-item>
        </el-form>
      </div>
    );
  }

  beforeConfirm(resp: {} = {}, cb) {
    this.$refs.form.validate((flag) => {
      this.confirmloading = flag;
      if (flag) {
        cb(resp);
      }
    });
  }
}
